import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoriesItem } from '../categories/categories.model';
import { NodeService } from '../../services/node-service/node-service.service';
// import { SubCategoriesDataSource } from './subcategories-datasource'; // <-- Ya no necesitas esto aquí si pasas el array directamente
import { Subscription } from 'rxjs';
import { RootcategoriesService } from '../rootcategories/rootcategories.service';
import { SubcategoryService } from './subcategory.service';
import { DialogLogsComponent } from '../dialog-logs/dialog-logs.component';
import { MatDialog } from '@angular/material/dialog';

export interface Response {
  label: string;
  body: CategoriesItem[] | any; // Puede ser CategoriesItem[] o PointOfInterest[] u otros datos
  category?: CategoriesItem; // Si el body de la respuesta incluye una propiedad 'category'
}

@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.css'],
  standalone: false,
})
export class SubcategoryComponent implements OnInit, OnDestroy {
  // data!: SubCategoriesDataSource; // <-- Elimina esta propiedad
  categoryId: number = 0;
  parent!: any; // Mejor tipar esto si conoces la estructura de 'category'
  currentCategory: string = 'category';
  viewTitle: string = 'Categorias';
  isPois: boolean = false;
  subcription: Subscription = new Subscription();
  subscriptionBulkStatus: Subscription = new Subscription();
  subscriptionDataPois: Subscription = new Subscription();
  displayedColumns = [
    'id',
    'nombre',
    'parent',
    'pois_count',
    'fuente',
    'red',
    'created_at',
    'actions',
  ];
  parentContent: CategoriesItem[] | any[] = []; // <-- Inicializa como un arreglo vacío y tipado para flexibilidad
  isNulledLabel: boolean = false;

  childCategoryId: number | undefined;

  constructor(
    public route: ActivatedRoute,
    private nodeService: NodeService,
    private rootCategoriesService: RootcategoriesService,
    private subcategoryService: SubcategoryService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.categoryId = parseInt(params['id']);
      this.nodeService.setCategoryId(this.categoryId);
      this.childCategoryId = this.categoryId;

      // Asegúrate de que subcategoryService.getCategory devuelva un Observable con la estructura correcta
      this.subcategoryService.getCategory(this.categoryId).subscribe({
        // Usamos el patrón de observer para manejo de next/error
        next: (response: any) => {
          // response.body contendrá { label, body, category? }
          const body = response.body; // Extrae el body de la respuesta HTTP completa

          this.displayedColumns = [
            'id',
            'nombre',
            'parent',
            'pois_count',
            'fuente',
            'red',
            'created_at',
            'actions',
          ];
          this.parent = body?.category; // Accede a 'category' si existe
          this.parentContent = body?.body || []; // <-- Pasa SOLO el arreglo de datos 'body.body' al input 'initialDataSourceData'

          if (!this.parent?.id) {
            this.rootCategoriesService.openSnacBar(
              'Ha ocurrido un error al cargar la categoría padre'
            );
          }

          if (body.label === 'pois') {
            this.viewTitle = 'Puntos de interés';
            this.isPois = true;
            this.nodeService.setPois(body.body);
          } else {
            this.isPois = false;
            this.viewTitle = 'Categorias';
          }

          if (body.label === null) {
            this.isNulledLabel = true;
          }

          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error al cargar la categoría específica:', error);
          this.rootCategoriesService.openSnacBar('Ha ocurrido un error al cargar la categoría');
          this.childCategoryId = undefined; // Para que CategoriesComponent no intente cargar con un ID fallido
          this.parentContent = []; // Asegura que si hay error, el input sea un arreglo vacío
          this.cdr.detectChanges();
        },
      });
    });
  }

  ngOnDestroy(): void {
    this.subcription.unsubscribe();
    this.subscriptionBulkStatus.unsubscribe();
    this.subscriptionDataPois.unsubscribe();
  }

  openDialogLogs() {
    this.subscriptionBulkStatus = this.subcategoryService
      .bulkLoadStatus(this.categoryId)
      .subscribe((resp) => {
        this.dialog.open(DialogLogsComponent, { data: resp });
      });
  }
}
